import {ArenasHeaderButtonsDefaultBox} from "./arenas-header-buttons.default.box";

export const ArenasHeaderButtonsBox = ArenasHeaderButtonsDefaultBox;